import styled from "styled-components";

import Icon from "konnekt/Icon";

export const Container = styled.div`
  background-color: #f5f5f5;
  padding: 14px 18px 8px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    background-color: transparent;

    border-bottom: 1px solid #e5e5e5;
    padding: 0 0 12px 0;
  }
`;

export const TextContainer = styled.div`
  position: sticky;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    position: relative;
    left: 0;
    transform: translateX(0);
  }
`;

export const Heading = styled.h2`
  font-size: 18px;
  margin-bottom: 0;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    font-size: 16px;
    font-weight: 600;
    width: unset;
  }
`;
export const SubHeading = styled.h3`
  font-size: 10px;
  margin-bottom: 0;
  text-align: center;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    text-align: left;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const BackIcon = styled(Icon)`
  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    display: none;
  }
`;

export const MessageTypeIcon = styled(Icon)`
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    display: flex;
    margin-right: 10px;
  }
`;

export const HeadingBox = styled.div`
  display: flex;
  align-items: center;
  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    margin-bottom: 5px;
  }
`;

export const RotateIcon = styled(Icon)`
  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    display: none;
  }
`;

export const CloseIcon = styled(Icon)`
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    display: flex;
    margin-left: 28px;
  }
`;
